import {
  GET_OUTLETS_FAILD,
  GET_OUTLETS_LOADING,
  GET_OUTLETS_SUCCESS,
} from "../types";

const initialState = {
  outlets: null,
  loading: false,
  error: null,
};

export const outLetsByMerchantReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_OUTLETS_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_OUTLETS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        outlets: action.payload,
      };
    case GET_OUTLETS_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};
